import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { ExcelService } from 'src/app/api/services/excel.service';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { ExcelDocumentDownloadResponseDto, SignalrService } from 'src/app/services/signalr.service';
import { ExcelDownloadDialogModel } from './excel-download-dialog.model';

@Component({
    selector: 'app-excel-download-dialog',
    templateUrl: './excel-download-dialog.component.html',
    styleUrls: ['./excel-download-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExcelDownloadDialogComponent implements OnInit {
  constructor(
    private excelService: ExcelService,
    private errorHandler: ErrorHandlerService,
    private signalR: SignalrService,
    private readonly http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: ExcelDownloadDialogModel
  ) {}

  unsubscribe$ = new Subject<void>();
  downloadUrl: string;
  fileName: string;
  error: string;
  limit: number;

  ngOnInit(): void {
    this.signalR.excelCreated$.pipe(takeUntil(this.unsubscribe$)).subscribe((result: ExcelDocumentDownloadResponseDto) => {
      const path = ExcelService.DownloadDocumentPath.replace('{documentId}', result.documentId);
      const blobLink = `${this.excelService.rootUrl}${path}`;
      this.limit = result.limit;
      this.fileName = result.documentId + '.Xlsx';

      this.http
        .get(blobLink, { responseType: 'blob' })
        .pipe(take(1))
        .subscribe((response) => {
          this.downloadUrl = URL.createObjectURL(response);
        });
    });

    this.signalR.excelCreateFailed$.pipe(takeUntil(this.unsubscribe$)).subscribe((message: string) => {
      this.error = `Excel kunne ikke dannes. Fejl: ${message}`;
    });

    this.excelService
      .createDocument({
        caller: EGIS_SERVICE_CALLER,
        body: {
          documentType: this.data.documentType,
          handlerType: this.data.handlerType,
          filter: this.data.filter,
        },
      })
      .subscribe({
        error: (err) => {
          this.errorHandler.HandleError(err);
          this.error = 'Fejl ved dannelse af fil';
        },
      });
  }
}
